import type { DOMConversionOutput } from "lexical";
import type { UUID } from "../../../../../utils/uuid";
import type { DynamicContentToolbarNode } from "./dynamic-content-toolbar-node";
import type { DynamicContentToolbarNodeMui } from "./dynamic-content-toolbar-node-mui";

export function isDynamicContentToolbarElement(node: HTMLElement): boolean {
  return node.tagName === "DIV" && node.getAttribute("data-node-type") === "dynamic-toolbar-node";
}

export function convertDynamicContentToolbarElement(
  domNode: Node,
  type: typeof DynamicContentToolbarNodeMui | typeof DynamicContentToolbarNode,
): DOMConversionOutput {
  if (domNode instanceof HTMLDivElement) {
    const segmentId = domNode.getAttribute("data-segment-id");
    const open = (domNode.getAttribute("data-open") ?? "true") === "true";
    const error = domNode.getAttribute("data-error");

    if (!segmentId) {
      return { node: null };
    }

    return {
      node: new type(segmentId as UUID, open, error ?? undefined),
    };
  }

  return { node: null };
}
